import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Field, FieldArray, useFormikContext } from 'formik';

import CustomCreatableMultiSelect from '../../../../../components/shared/CustomCreatableMultiSelect/CustomCreatableMultiSelect';
import { getTags } from '../../../../../redux/actions/networkActions';

const ContactFormTags = ({ showModal }) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const tags = useSelector((state) => state.networkReducer.tags);
  const { values, setValues } = useFormikContext();

  const formatData = useMemo(() => {
    const data = values.taggings_attributes;
    const newData = data.map((val) => {
      const { _destroy } = val;
      if (!_destroy && val.general_tags_attributes.name.length) {
        const body = {
          value: val.general_tags_attributes.name,
          label: val.general_tags_attributes.name,
        };
        if (val.id) {
          body.id = val.id;
        }
        return body;
      }
    });
    return newData.filter((val) => val);
  }, [values]);

  const formatTags = useMemo(() => tags.map((tag) => ({ id: tag.id, value: tag.name, label: tag.name })), [tags]);

  const findIndexTag = (tag) => {
    const data = values.taggings_attributes;
    return data.findIndex((val) => val?.general_tags_attributes.name === tag);
  };

  useEffect(() => {
    if (showModal) {
      dispatch(getTags());
    }
  }, [showModal]);

  const handleOnChange = (data, arrayHelpers) => {
    const newData = data[data.length - 1];
    if (!formatData.includes(newData)) {
      const body = { general_tags_attributes: { name: newData.label } };
      if (newData.id) {
        body.id = newData.id;
      }
      arrayHelpers.insert(values.taggings_attributes.length + 1, body);
    }
  };

  const handleRemoveTag = (option, arrayHelpers) => {
    const newData = values.taggings_attributes;
    const index = findIndexTag(option);
    if (index >= 0) {
      if (newData[index]?.id) {
        newData[index] = { ...newData[index], _destroy: true };
        setValues({ ...values, taggings_attributes: newData });
      } else {
        arrayHelpers.remove(index);
      }
    }
  };

  return (
    <FieldArray
      name="taggings_attributes"
      render={(arrayHelpers) => (
        <div>
          <Field
            as={CustomCreatableMultiSelect}
            placeholder={t('placeholders.tag')}
            options={formatTags}
            isSearchable
            value={formatData}
            handleOnChange={(data) => handleOnChange(data, arrayHelpers)}
            showIcon
            handleRemoveTag={(data) => handleRemoveTag(data, arrayHelpers)}
          />
        </div>
      )}
    />
  );
};

export default ContactFormTags;
